export default "__VITE_ASSET__CQjffR3f__"